export default {
  // The blog's title as it appears in the layout header, and in the document
  // <title> tag.
  title: "Proximity",

  author: "Strategic Machines",
  description: "Innovation at the Edge",

  // The number of posts to a page on the site index.
  indexPageSize: 6,
}
